export interface KioskPreferences {
    general: KioskGeneralPreferences;
    theme: KioskThemePreferences;
    product: KioskProductPreferences;
    printer: KioskPrinterPreferences;
}

export type KioskAllPreferenceType =
    | KioskPreferenceType
    | KioskThemePreferenceType
    | KioskProductPreferenceType
    | KioskPrinterPreferencesType;

export enum KioskPreferenceType {
    KIOSK_START_SCREEN_LOCATION = "kioskStartScreenLocation",
    KIOSK_HOME_SHOW_PURCHASE_BTN = "kioskHomeShowPurchaseBtn",
    KIOSK_HOME_SHOW_CHECKIN_BTN = "kioskHomeShowCheckinBtn",
    KIOSK_HOME_SHOW_WAIVER_BTN = "kioskHomeShowWaiversBtn",
    KIOSK_IDLE_RESET_TIME_ENABLED = "kioskIdleResetTimeEnabled",
    KIOSK_IDLE_RESET_TIME = "kioskIdleResetTime",
    KIOSK_SETTINGS_PASSWORD = "kioskSettingsPassword",
    KIOSK_PURCHASE_NAME_REQUIRED = "kioskPurchaseNameRequired",
    KIOSK_PURCHASE_PHONE_REQUIRED = "kioskPurchasePhoneRequired",
    KIOSK_PURCHASE_EMAIL_REQUIRED = "kioskPurchaseEmailRequired",
}

export enum KioskStartScreenOptions {
    HOME = "Home",
    CHECKIN = "SearchOrders",
    NEWBOOKING = "SelectExperiences",
    WAIVERS = "SearchWaivers",
}

export interface KioskGeneralPreferences {
    [KioskPreferenceType.KIOSK_START_SCREEN_LOCATION]: KioskStartScreenOptions;
    [KioskPreferenceType.KIOSK_HOME_SHOW_PURCHASE_BTN]: boolean;
    [KioskPreferenceType.KIOSK_HOME_SHOW_CHECKIN_BTN]: boolean;
    [KioskPreferenceType.KIOSK_HOME_SHOW_WAIVER_BTN]: boolean;
    [KioskPreferenceType.KIOSK_IDLE_RESET_TIME_ENABLED]: boolean;
    [KioskPreferenceType.KIOSK_IDLE_RESET_TIME]: number;
    [KioskPreferenceType.KIOSK_SETTINGS_PASSWORD]: string;
    [KioskPreferenceType.KIOSK_PURCHASE_NAME_REQUIRED]: boolean;
    [KioskPreferenceType.KIOSK_PURCHASE_PHONE_REQUIRED]: boolean;
    [KioskPreferenceType.KIOSK_PURCHASE_EMAIL_REQUIRED]: boolean;
}

export enum KioskThemePreferenceType {
    KIOSK_HOME_BACKGROUND = "kioskHomeBackground",
    KIOSK_HEADER_IMAGE = "kioskHeaderImage",
    KIOSK_ATTRACT_VIDEO = "kioskAttractVideo",
}

export enum KioskImageTargets {
    HEADER = "kiosk_header",
    BACKGROUND = "kiosk_background",
    RECEIPT_TICKET = "kiosk_receipt_ticket",
}

export interface KioskThemePreferences {
    [KioskThemePreferenceType.KIOSK_HOME_BACKGROUND]: string;
    [KioskThemePreferenceType.KIOSK_HEADER_IMAGE]: string;
    [KioskThemePreferenceType.KIOSK_ATTRACT_VIDEO]: string;
}

export enum KioskProductPreferenceType {
    KIOSK_PRODUCT_DISPLAY = "kioskProductDisplay",
    KIOSK_PRODUCT_LIST = "kioskProductList",
}

export enum KioskProductDisplayOrder {
    GRID = "grid",
    LIST = "list",
}

export interface KioskProductPreferences {
    [KioskProductPreferenceType.KIOSK_PRODUCT_DISPLAY]: KioskProductDisplayOrder;
    [KioskProductPreferenceType.KIOSK_PRODUCT_LIST]: Array<ID>;
}

export interface KioskFieldConfig {
    name: KioskAllPreferenceType;
    label: string;
    children?: string | null;
    field?: "switch" | "text" | "dropdown";
    tooltip?: string;
    fieldAttr?: {
        values: Array<Record<string, string>>;
    };
}

export interface KioskGeneralFieldConfig {
    name: KioskPreferenceType;
    label: string;
    children?: string | null;
    field?: "switch" | "text" | "dropdown";
    tooltip?: string;
    fieldAttr?: {
        values: Array<Record<string, string>>;
    };
}

export interface KioskImageFieldConfig extends KioskFieldConfig {
    src: string;
    uploadUrl: string;
    onUpdated: (response: any) => void;
    hasDelete: boolean;
    onDelete: () => void;
}

export interface ProductSelectionState {
    all: boolean;
    selected: string[];
}

export enum KioskPrinterPreferencesType {
    KIOSK_PRINTER_IMAGE = "kioskPrinterTicketImage",
    KIOSK_PRINTER_MESSAGE = "kioskPrinterTicketMessage",
    KIOSK_PRINTER_PRINT_RECEIPTS = "kioskPrinterPrintReceipts",
    KIOSK_PRINTER_PRINT_QR_TICKETS = "kioskPrinterPrintQrTickets",
}

export interface KioskPrinterPreferences {
    [KioskPrinterPreferencesType.KIOSK_PRINTER_IMAGE]: string;
    [KioskPrinterPreferencesType.KIOSK_PRINTER_MESSAGE]: string;
    [KioskPrinterPreferencesType.KIOSK_PRINTER_PRINT_RECEIPTS]: boolean;
    [KioskPrinterPreferencesType.KIOSK_PRINTER_PRINT_QR_TICKETS]: boolean;
}
